import { getInitialState, getPath } from "../../utils";

const initialState = {
  pendingDeductions: [],
  currentPage: 1,
  nextPage: -1,
  prevPage: -1,
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_PENDING_DEDUCTION_LIST":
      return setPendingDeductionList(state, action);
    case "SET_PENDING_DEDUCTION_ACTIVE_FILTERS":
      return setPendingDeductionActiveFilters(state, action);
    case "SET_PENDING_DEDUCTION_CURRENT_PAGE":
      return setPendingDeductionCurrentPage(state, action);
    default:
      return state;
  }
}

const setPendingDeductionList = (state, action) => {
  return {
    ...state,
    pendingDeductions: getPath(action.payload, "data", []),
    nextPage: getPath(action.payload, "pageRequest.nextPage", []),
    prevPage: getPath(action.payload, "pageRequest.prevPage", []),
  };
};
const setPendingDeductionActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
const setPendingDeductionCurrentPage = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};
